import React from "react";

const CookiePolicy = () => (
  <div className="min-h-screen bg-black text-white flex flex-col items-center py-12 px-4">
    <div className="w-full max-w-2xl mx-auto">
      <h1 className="text-3xl font-semibold font-primary text-center mb-2 mt-4">
        FOZZIL Cookie Policy
      </h1>
      <div className="text-gray-300 italic text-center mb-10 text-lg">
        Last Updated: April 13, 2025
      </div>
      <p className="mb-6 text-lg leading-relaxed">
        This Cookie Policy outlines how FOZZIL uses cookies and similar
        technologies across our web-based services, including{" "}
        <span className="underline">https://fozzil.in</span> and related
        domains. For details on how we collect and process your personal
        information, please refer to our Privacy Policy.
      </p>
      <h2 className="text-2xl font-bold mb-3 mt-10">What Are Cookies?</h2>
      <p className="mb-6 text-lg leading-relaxed">
        Cookies are small text files that may be stored on your device when you
        access a website or web-based application. They allow websites to
        recognize your device, remember preferences, and enhance the
        performance, functionality, and security of services.
        <br />
        We may also use technologies similar to cookies, such as local storage,
        to help us operate and improve our digital platforms.
      </p>
      <h2 className="text-2xl font-bold mb-3 mt-10">
        Why Does FOZZIL Use Cookies?
      </h2>
      <p className="mb-6 text-lg leading-relaxed">
        FOZZIL only uses strictly necessary cookies that are essential for the
        operation, security, and basic functionality of our services. We do not
        use cookies for advertising, marketing, or user tracking beyond what is
        required to secure and deliver core functionality.
        <br />
        These cookies help us:
      </p>
      <ul className="mb-8 text-lg list-disc list-inside space-y-1">
        <li>Ensure account and session security</li>
        <li>Enable secure login and user authentication</li>
        <li>Maintain essential service functionality</li>
      </ul>
      <p className="mb-6 text-lg leading-relaxed">
        Since these cookies are required for our systems to work properly, they
        cannot be disabled through standard cookie controls.
      </p>
      <h2 className="text-2xl font-bold mb-3 mt-10">List of Cookies Used</h2>
      <div className="overflow-x-auto mb-8">
        <table className="min-w-full text-lg text-left border border-gray-700">
          <thead className="bg-gray-800">
            <tr>
              <th className="py-2 px-4 border-b border-gray-700">Source</th>
              <th className="py-2 px-4 border-b border-gray-700">Name</th>
              <th className="py-2 px-4 border-b border-gray-700">Purpose</th>
              <th className="py-2 px-4 border-b border-gray-700">Duration</th>
              <th className="py-2 px-4 border-b border-gray-700">Domain</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="py-2 px-4 border-b border-gray-700">FOZZIL</td>
              <td className="py-2 px-4 border-b border-gray-700">csrf</td>
              <td className="py-2 px-4 border-b border-gray-700">Security</td>
              <td className="py-2 px-4 border-b border-gray-700">30 mins</td>
              <td className="py-2 px-4 border-b border-gray-700">All</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b border-gray-700">FOZZIL</td>
              <td className="py-2 px-4 border-b border-gray-700">sso</td>
              <td className="py-2 px-4 border-b border-gray-700">Login</td>
              <td className="py-2 px-4 border-b border-gray-700">4 weeks</td>
              <td className="py-2 px-4 border-b border-gray-700">All</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b border-gray-700">FOZZIL</td>
              <td className="py-2 px-4 border-b border-gray-700">referrer</td>
              <td className="py-2 px-4 border-b border-gray-700">
                Service Functionality
              </td>
              <td className="py-2 px-4 border-b border-gray-700">30 days</td>
              <td className="py-2 px-4 border-b border-gray-700">
                intelligence.fozzil.in
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="mb-8 text-lg leading-relaxed">
        Note: FOZZIL may update this list periodically to reflect changes in
        cookie usage as part of service improvements.
      </p>
      <h2 className="text-2xl font-bold mb-3 mt-10">Contact Us</h2>
      <p className="mb-2 text-lg">
        For questions or concerns regarding our use of cookies, please contact:
        <br />
        <span className="block mt-2">
          📩{" "}
          <a
            href="mailto:legal@fozzil.in"
            className="underline hover:text-blue-400"
          >
            legal@fozzil.in
          </a>
        </span>
      </p>
    </div>
  </div>
);

export default CookiePolicy;
